export const saveToStore = (name: string, data: string) => {
  localStorage.setItem(name, data)
}

export const getItemFromStore = (name: string): string | null => {
  return localStorage.getItem(name)
}
